import { get } from "./axiosClient"

type GetCypherPDfProps = {
    token: string,
    id: number
}


type GetCypherPdfResponse = {
    cypherPdf?: string,
    errorMessage?: string
}


export const getCypherPDF = async ({ id, token }: GetCypherPDfProps): Promise<GetCypherPdfResponse> => {
    return await get({
        params: {id: id},
        path: 'websystem/cypherPdf',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { cypherPdf: res.data }
        } else {
            return { errorMessage: res.data }
        }
    });
}